/** @format */

import {ButtonProps} from '@mui/material';

import {Root, RootProps} from './styles';

/*
todo: добавить другие варианты дизайна
https://www.figma.com/design/mP6RofMLQpZ6PVjaW7z0Su/AdSensor-2025?node-id=509-4040&t=6i3a0yq2LLhdMhwg-4
 */

type Props = RootProps & ButtonProps;

const BlueButton = ({size = 'medium', ...props}: Props) => {
  return <Root size={size} {...props} />;
};

export {BlueButton};
